<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex md6 class="col-12 fxt-bg-img flex-b" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                                                         
                <!--**********************   Form   ************************************************** -->
                 <div v-show="isShowLinkDiv" class="fxt-form">
                  <h2>{{$t("closeGoogleAuthentication.hint")}}</h2>
                  <v-form ref="closeAuthenticationForm" v-model="closeAuthenticationValid">
                    <v-text-field disabled v-model="closeAuthenticationForm.regEmail" label="E-mail" required></v-text-field>
                    <v-text-field disabled v-model="closeAuthenticationForm.authenticationSecret" label="Secret Key" required></v-text-field>
                    <v-text-field v-model="passWord" :label="$t('header.passwordHint')" :rules="passWordRules" type="password" required></v-text-field>
                    <v-btn color="primary white--text" :disabled="!closeAuthenticationValid" @click="closeAuthentication">{{$t("common.submit")}}</v-btn>
                  </v-form>
                </div>
                <div v-show="!isShowLinkDiv" class="mt-5 mb-3">
                  <h3>{{$t("activation.valid")}}</h3>
                  <v-btn round flat outline class="mt-5 fw-bold primary--text" @click="goHomePage">{{$t("page404.homepageButton")}}</v-btn>
                </div>
                </div> 
                <div class="fxt-footer">
                    <ul class="fxt-socials">
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                            <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                        </li>
                    </ul>
                </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>
<style>
</style>
<script>
import Vue from "vue";
import Md5 from "js-md5";
import config from "../../config.js";
export default {
  data() {
    return {
      isShowLinkDiv: false, //是否显示链接div
      closeAuthenticationValid: true, //表单有效性
      passWord: "", //输入的密码
      closeAuthenticationForm: {
        //关闭时验证的对象
        id: null, //userId
        regEmail: null, //邮箱
        authenticationSecret: null, //秘钥
        passWord: null //密码
      },
      passWordRules: [
        //密码认证规则
        v => !!v || this.$t("header.passwordHintEmpty"),
        v => (v && v.length >= 8) || this.$t("header.passwordHintLength")
      ]
    };
  },
  computed: {},
  created() {
    this.verifyLink();
  },
  mounted() {},
  watch: {
    $route: "verifyLink"
  },
  methods: {
    //验证链接是否有效
    verifyLink() {
      let currentUrl = window.location.href;
      let emailLinkId = currentUrl.substring(
        currentUrl.lastIndexOf("/") + 1,
        currentUrl.length
      );
      let verifyUrl =
        config.baseUrl +
        "emailLink/open/verifyGoogleCodeLink?emailLinkId=" +
        emailLinkId;
      this.$http.get(verifyUrl).then(response => {
        let data = response.data;
        if (data.resCode == 0) {
          //正常访问，显示div
          this.isShowLinkDiv = true;
          this.closeAuthenticationForm.id = data.result.userId;
          this.closeAuthenticationForm.regEmail = data.result.regEmail;
          this.closeAuthenticationForm.authenticationSecret =
            data.result.authenticationSecret;
        } else if (data.resCode == -1) {
        } else if (data.resCode == -2) {
        }
      });
    },
    //关闭认证
    closeAuthentication() {
      if (this.$refs.closeAuthenticationForm.validate()) {
        let closeAuthenticationUrl =
          config.baseUrl + "user/open/closeAuthenticationBySecret";
        var password = Md5(this.passWord);
        password = password
          .split("")
          .reverse()
          .join("");
        this.closeAuthenticationForm.passWord = Md5(password);
        this.$http
          .post(closeAuthenticationUrl, this.closeAuthenticationForm)
          .then(response => {
            let data = response.data;
            if (data.resCode == 0) {
              //关闭认证成功，发送关闭认证通知邮件
              this.sendCloseAuthenticationNoticeEmail();
              this.$refs.closeAuthenticationForm.reset();
              this.passWord = "";
              this.goHomePage();
            } else if (data.resCode == -4) {
              this.$Message.error(this.$t("header.passwordWrongMessage"));
            }
          });
      }
    },
    //发送关闭认证通知邮件
    sendCloseAuthenticationNoticeEmail() {
      this.$http.get(
        config.baseUrl +
          "sendEmail/open/sendCloseAuthenticationNoticeEmail?email=" +
          this.closeAuthenticationForm.regEmail
      );
    },
    //跳转到主页
    goHomePage() {
      window.location.href = config.ip;
    }
  }
};
</script>


// WEBPACK FOOTER //
// CloseGoogleAuthentication.vue?38f35ef6